
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LockIcon from 'Components/icons/LockIcon';
import UnlockIcon from 'Components/icons/UnlockIcon';
import Loader from 'Assets/img/dims-detokenized-loader.svg';
import CardType from 'Components/CardType';
import { getOriginalCardNumber } from 'Apis/tokenizationAPI.js';
import { cardNumberNotificationBanner, closeNotificationBanner } from 'Actions/notificationAction';
import { setAccountNumberId, unLockAccountNumber } from 'Actions/accountNumberAction';
import './GDAccountNumberCell.scss';
import { loadState } from '../../../../app/src/store/browserStorage';

export class GDAccountNumberCell extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isDetokenize: false,
      targetDone: false,
      isLoading : false
    };
    this.showOriginalCardNumber = this.showOriginalCardNumber.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.copyToClipBoard = this.copyToClipBoard.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.unAuthorizedDetokenization = this.unAuthorizedDetokenization.bind(this);
    this.setClassNameOnAction = this.setClassNameOnAction.bind(this);
  }
 
  showOriginalCardNumber(globalToken) {
    this.setState({
      isLoading: true,
    },()=>{
      this.props.setAccountNumberId(this.props.id);
    })
    const auth = loadState('auth');
    const userPermission = auth !== undefined && auth.user !== undefined ? auth.user.parsedPermissions : undefined;
    if (userPermission !== undefined && !userPermission.accountNumber.canViewFullNumber) {
      this.unAuthorizedDetokenization();
    } else {
      getOriginalCardNumber(globalToken).then((response) => {
        this.setState({
          isLoading: false
        })
        const cardNumber = response.data.cc;
        this.props.unLockAccountNumber(true);
        this.props.setAccountNumberId(this.props.id);

        this.props.cardNumberNotificationBanner([{
          title: 'Card Number Detokenized',
          timeLeft: 60,
          titleStyle: "color: '#007dc3'",
          descriptionStyle: "color: 'grey'",
          type: 'info',
          textField: true,
          primaryButtonAction: () => this.copyToClipBoard(cardNumber),
          primaryButtonActionValue: cardNumber,
          cancel: true,
          cancelButtonText: 'Dismiss',
          isSecondaryButtonActive: this.state.targetDone,
          isSecondaryButton: 'Dismiss',
          secondaryButtonText: 'COPIED TO CLIPBOARD',
          secondaryButtonAction: this.closeNotification,
          closeNotification: this.closeNotification,
          valueStyle: "color: 'black'",
        }]);
      }).catch((error) => {
        this.setState({
          isLoading: false,
          errorId:this.props.id
        });
        this.props.setAccountNumberId(true);
        this.props.unLockAccountNumber(false);

        this.props.cardNumberNotificationBanner([{
          title: 'System Error: Unable to get original card number',
          descriptionStyle: "color: 'grey'",
          type: 'danger',
          cancelButtonText: 'Dismiss',
          cancelOnly: true,
          closeNotification: this.closeNotification,
          valueStyle: "color: 'black'",
        }]);

        console.error('Unable to get original card number from global token', error);
      });
      this.setState({
        targetDone: false,
      })
    }
  }
  unAuthorizedDetokenization() {
    this.props.setAccountNumberId(true);
    this.props.unLockAccountNumber(false);
    this.props.cardNumberNotificationBanner([{
      title: 'You are not authorized to view full card number',
      descriptionStyle: "color: 'grey'",
      type: 'danger',
      cancelButtonText: 'Dismiss',
      cancelOnly: true,
      closeNotification: this.closeNotification,
      valueStyle: "color: 'black'",
    }]);
    this.setState({
      targetDone: false,
    })
  }

  copyToClipBoard(value) {
    const textareaElement = document.createElement('textarea');
    document.body.appendChild(textareaElement);
    textareaElement.value = value;
    textareaElement.select();
    document.execCommand('copy');
    document.body.removeChild(textareaElement);

    this.closeNotification();
  }

  closeNotification() {
    this.setState({
      targetDone: false,
      errorId:null
    });

    this.props.setAccountNumberId(-1);
    this.props.closeNotificationBanner();
  }

  closeBanner() {
    this.props.setAccountNumberId(true);
  }

  setClassNameOnAction (){
    let finalClassName = "";
    if(typeof this.props.lockedId == "number"){ /*when nothing is clicked */
      finalClassName = "gd-accountnumber-cell";
    }
    if(typeof this.props.lockedId == "string"){ /*when a cell is clicked,apply for all except the selected one */
      finalClassName = "gd-accountnumber-cell-external read-only-mode blur-accountnumbers";
    }

    if(typeof this.props.lockedId == "boolean"){ /*when a cell is clicked,apply for all except the selected one */
      finalClassName = "gd-accountnumber-cell-external read-only-mode blur-accountnumbers";
    }
    if(this.props.lockedId == this.props.id){ /*when a cell is clicked,apply for that particular cell onSuccess*/
      finalClassName = "gd-accountnumber-cell-lock read-only-mode"
    }
    if(typeof this.props.lockedId == "boolean" && this.state.errorId === this.props.id){/*when a cell is clicked,apply for that particular cell onError*/
      finalClassName = "gd-accountnumber-cell-lock read-only-mode";
    }
    if(typeof this.props.lockedId == "boolean" && this.state.errorId !== this.props.id){/*when a cell is clicked,apply for all others*/
      finalClassName = "gd-accountnumber-cell-external read-only-mode blur-accountnumbers";
    }
    if(!this.props.locked && typeof this.props.lockedId != "boolean"){ /*when pop is closed automatically */
      finalClassName = "gd-accountnumber-cell";
    }
    return finalClassName;
   }
 
  render() {
    return (
       <div
        className={this.props.isReadOnly ? "gd-accountnumber-cell-lock" : this.props.isMerchantPortal ? "gd-accountnumber-cell-external" : this.setClassNameOnAction()}
        role="button"
        key={this.props.id}
        style={this.props.accountNumberStyle ? this.props.accountNumberStyle : {}}
        onClick={this.props.isMerchantPortal || this.props.isReadOnly ? () => { } : () => this.showOriginalCardNumber(this.props.token)}
      >
        
        {!this.props.isMerchantPortal && this.props.showCardLogo && <span className="unmatched-card-type-logo">
              <CardType
                isUnmatchedQueue={true}
                abbreviation={this.props.cardBrandCode}
                type={this.props.cardBrandCode}
                alt={this.props.cardBrandCode}
              />
            </span>}
            {this.state.isLoading ? <div className="default-loading-style">
          <span id="overlay-loading"><object type="image/svg+xml" className="overlay-loading-view" data={Loader} /></span>
          <span className={this.state.isLoading ? "blur-accountnumbers":this.props.isMerchantPortal || this.props.isReadOnly ? "read-only-mode" : ""}>{this.props.accountNumber?.replace(/(X)/ig || /(x)/ig, '*')} {!this.props.isMerchantPortal && (this.props.lockedId === this.props.id && this.props.locked ? <UnlockIcon /> : <LockIcon />)}</span>

        </div> : <div className="default-loading-style">
            <span className={this.props.isMerchantPortal || this.props.isReadOnly ? "read-only-mode" : ""}>{this.props.accountNumber?.replace(/(X)/ig || /(x)/ig, '*')} {!this.props.isMerchantPortal && (this.props.lockedId === this.props.id && this.props.locked ? <UnlockIcon /> : <LockIcon />)}</span>
          </div>}
        {/* TODO Add UnlockIcon when id handling is implemented */}
      </div>
    );
  }
}

GDAccountNumberCell.propTypes = {
  cardNumberNotificationBanner: PropTypes.func,
  accountNumber: PropTypes.string,
  token: PropTypes.string.isRequired,
  lockedId: PropTypes.number,
  locked: PropTypes.bool,
  id: PropTypes.string,
  isReadOnly: PropTypes.bool,
  isMerchantPortal: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  lockedId: state.accountNumber.lockedId,
  locked: state.accountNumber.locked,
});

const mapDispatchToProps = (dispatch) => {
  return {
    cardNumberNotificationBanner: (banner) => dispatch(cardNumberNotificationBanner(banner)),
    closeNotificationBanner: () => dispatch(closeNotificationBanner()),
    setAccountNumberId: (locked) => dispatch(setAccountNumberId(locked)),
    unLockAccountNumber: (locked) => dispatch(unLockAccountNumber(locked)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GDAccountNumberCell);
